<template>
  <div class="main-page">
    <Menus title="人民调解" :home="true" />
    <div class="container-flex">
      <div class="content">
        <Applyinfo :url="url"></Applyinfo>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Applyinfo from '../../components/Applyinfo'
export default {
  components: {
    Menus,
    Applyinfo
  },
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    this.url = this.$route.query.url
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 12.7rem
  margin 0.6rem auto 70vh auto
</style>
